export enum ModelPreference {
  MEDIUM = 'medium',
  HIGH = 'high',
}

interface IModelSelectorProps {
  model: ModelPreference;
  onChange: (model: ModelPreference) => void;
  disabled?: boolean;
  options: { value: ModelPreference; label: string; description: string; badge?: string }[];
}

export type { IModelSelectorProps };